module.exports = __webpack_public_path__ + "img/ch-poster.9954c79e.png";